module.exports = __webpack_public_path__ + "static/img/home_day1.0edf384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_day1.png
// module id = kFde
// module chunks = 4